import type { SignalRTvHubOptions, TvHub, TvListener } from './hub';

/**
 * O mesmo `TvHub`, mas só carrega o SignalR (uns 60 KB) quando a tela da TV abre com um pareamento: quem usa o app no celular
 * nunca baixa o cliente do hub da TV.
 */
export class LazyTvHub implements TvHub {
  private implementation: Promise<TvHub> | null = null;

  constructor(private readonly options: SignalRTvHubOptions) {}

  private load(): Promise<TvHub> {
    this.implementation ??= import('./hub').then((module) => new module.SignalRTvHub(this.options));
    return this.implementation;
  }

  /** Assiste quando o módulo carregar; cancelar antes disso desfaz o pedido. */
  watch(listener: TvListener): () => void {
    let stop: (() => void) | undefined;
    let cancelled = false;

    void this.load().then((hub) => {
      if (!cancelled) {
        stop = hub.watch(listener);
      }
    });

    return () => {
      cancelled = true;
      stop?.();
    };
  }

  async resume(): Promise<void> {
    if (this.implementation) {
      await (await this.implementation).resume();
    }
  }

  async stop(): Promise<void> {
    if (this.implementation) {
      await (await this.implementation).stop();
    }
  }
}
